import { useContext, useState } from 'react';
import { deleteFavorite, postFavorite } from 'src/libs/api/favorites';
import type { Product } from 'src/models/product/schema';
import { AuthContext } from 'src/stores/Auth';
import { BrowserCacheContext } from 'src/stores/BrowserCache';
import { I18nContext } from 'src/stores/I18n';
import { useModal } from './useModal';

export const useFavorite = (quantity: number, productData: Product) => {
  const { setIsVisible, setModalParams } = useModal('noticeModal');
  const { setModalParams: setLoginModalParams, setIsVisible: setIsLoginModalVisible } = useModal('loginModal');

  const localeResources = useContext(I18nContext);
  const { checkedFavList } = useContext(BrowserCacheContext);
  const [favList, setFavList] = useState<{ [key: string]: boolean } | null>(checkedFavList.get());
  const { user } = useContext(AuthContext);

  const checkIsFavorite = (list: { [key: string]: boolean } | null): boolean => {
    if (!list) return false;
    if (Object.keys(list).find((id) => id === String(productData.productId))) {
      return true;
    } else {
      return false;
    }
  };

  //お気に入りボタン用関数
  const onFavButtonClick = (clickedSection: string) => {
    if (!user) {
      setLoginModalParams({
        title: localeResources.favorites.notLogin
      });
      setIsLoginModalVisible(true);
      return;
    }
    //現在のFavリストのkeyを回して同じ値があったら削除、なかったら追加
    if (favList && checkIsFavorite(favList)) {
      deleteFavorite([
        {
          productId: productData.productId
        }
      ]);
      delete favList[productData.productId];
      checkedFavList.set(favList);
      setFavList({ ...favList });
    } else {
      checkedFavList.set({ ...favList, [String(productData.productId)]: true });
      setFavList({ ...favList, [String(productData.productId)]: true });
      postFavorite(
        [
          {
            productId: productData.productId,
            quantity: quantity
          }
        ],
        clickedSection
      );
      setModalParams({
        type: 'info',
        title: localeResources.favorites.addedToFavorite
      });
      setIsVisible(true);
    }
  };
  return {
    isFavorite: checkIsFavorite(favList),
    onFavButtonClick
  };
};
